import { useLazyQuery, useQuery } from '@apollo/client'
import { GET_OPERATIONAL_DASHBOARD } from '../queries/operationalDashboardQueries';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { dashboardCreator } from 'state/index';
import { DashboardFilters } from 'interfaces/dashboards';

const useGetOperationalDashboard = () => {
	const dispatch = useDispatch();
	const { getOperationalDashboard } = bindActionCreators(dashboardCreator, dispatch)

	return useQuery(GET_OPERATIONAL_DASHBOARD, {
		onCompleted: (data: any) => {
			getOperationalDashboard(data.getOperationalDashboard);
		}
    });
}

const useLazyGetOperationalDashboard = () => {
	const dispatch = useDispatch();
	const { getOperationalDashboard } = bindActionCreators(dashboardCreator, dispatch)

	return useLazyQuery(GET_OPERATIONAL_DASHBOARD, {
		onCompleted: (data: any) => {
			getOperationalDashboard(data.getOperationalDashboard);
		}
    });
}


export {
    useGetOperationalDashboard,
    useLazyGetOperationalDashboard
}
